import { render, staticRenderFns } from "./CustomOfferGlobal.vue?vue&type=template&id=5d9fdfc1&scoped=true&"
import script from "./CustomOfferGlobal.vue?vue&type=script&lang=js&"
export * from "./CustomOfferGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fdfc1",
  null
  
)

export default component.exports